export const chartTheme = {
  gridColor: 'var(--chart-grid)',
  axisColor: 'var(--chart-axis)',
  axisFontSize: 12,
  tickLine: false,
  tooltipBackground: 'var(--chart-tooltip-bg)',
  tooltipBorder: 'var(--chart-tooltip-border)',
  tooltipShadow: 'var(--chart-tooltip-shadow)',
  tooltipRadius: 'var(--chart-tooltip-radius)',
  tooltipText: 'var(--chart-tooltip-text)',
  palette: [
    'var(--chart-series-1)',
    'var(--chart-series-2)',
    'var(--chart-series-3)',
    'var(--chart-series-4)',
  ],
  accent: 'var(--chart-accent)',
  /** Keep in sync with `--chart-area-fill-top` in tokens.css */
  areaFillTop: 0.28,
  areaFillBottom: 0,
};

export function getSeriesColor(index, providedColor) {
  if (providedColor) return providedColor;
  const palette = chartTheme.palette;
  return palette[index % palette.length];
}
